<ng-select [items]="items$ | async" [addTag]="addTag ? onAddTag : false" groupBy="group" [appendTo]="appendTo" bindLabel="name" [placeholder]="placeholder" [hideSelected]="true" [searchFn]="searchFn" [multiple]="multiple" [searchable]="true" [formControl]="control">
    <ng-template ng-option-tmp let-item="item">

        <div class="flex-row">
            <profile class="user" [userId]="$safeNavigationMigration(item?._id)" [userName]="$safeNavigationMigration(item?.name)"></profile>
            <div class="flex-column flex-fill">
                <div class="item-name">{{item?.name}}</div>
                <div class="item-email" [ngClass]="{'text-danger': $safeNavigationMigration(item?.disabled)}">{{item?.mobile}}</div>
            </div>
        </div>

    </ng-template>

    <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <div class="item-value">{{getDisplayValue(item)}}</div>
        <span class="ng-value-icon ml-5" [ngClass]="{'multiple':multiple}" (click)="clear(item)">×</span>
    </ng-template>
</ng-select>